export default __webpack_public_path__ + "static/media/Calendar.a8eff624.svg";